import { render, staticRenderFns } from "./request_approve.vue?vue&type=template&id=55b5e35e&scoped=true&"
import script from "./request_approve.vue?vue&type=script&lang=js&"
export * from "./request_approve.vue?vue&type=script&lang=js&"
import style0 from "./request_approve.vue?vue&type=style&index=0&id=55b5e35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5e35e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('55b5e35e', component.options)
    } else {
      api.reload('55b5e35e', component.options)
    }
    module.hot.accept("./request_approve.vue?vue&type=template&id=55b5e35e&scoped=true&", function () {
      api.rerender('55b5e35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/request_approve.vue"
export default component.exports